export enum InvoiceType {
    Unknown = 'Unknown',
    Income = 'Income',
    Expenses = 'Expenses',
    Sales = 'Sales',
}
